// 设置sessionId
export const SESSION_ID = 'sessionId'
// 登出，清除用户权限数据
export const LOGOUT = 'logout'
// 设置用户信息
export const USER_INFO = 'userInfo'
// 重置标签页状态
export const RESETPAGELIST = 'resetPageList'
// 设置标签页状态
export const GETPAGELIST = 'getPagelist'
//
export const REMOVETAB = 'removetab'
// 设置固定标签页
export const FIXTAB = 'fixtab'
// 设置权限列表
export const PERMISSION_LIST = 'permissionList'
// 企业id
export const COMPANY_ID = 'companyid'
// 管控id
export const CONTROL_ID = 'controlid'
// 变更管理
export const CHANGEINFO = 'changeinfo'
// 变更管理删除
export const CHANGEDELETE = 'changedelete'
// 变更管理清空
export const CHANGECLEAR = 'changeclear'
// 添加负责人
export const ADDSTAFF = 'addstaff'
// 删除负责人
export const DELETESTAFF = 'deletestaff'
// 当前属于哪个端
export const ROLE = 'role'
export const RISKLEVEL = 'riskLevel'
// 上次填报时间
export const EDITTIME = 'editTime'
// 跳转时需要的动态url
export const SYSURL = 'sysUrl'
export const GETSYSSETTINGS = 'getSysSettings'
export const CURRENTROW = 'currentRow'
export const CURRENTPAGE = 'currentPage'
// 跳转时保存所有的筛选状态
export const SEARCHFORM = 'searchForm'
export const ADVANCEFORM = 'AdvancedForm'
export const ADVANCEDSEARCH = 'advancedSearch'
// 填报进度
export const STEPSACTIVE = 'stepsActive'
// 行业监管部门
export const DEPARTMENTOPTIONS = 'departmentOptions'



// WEBPACK FOOTER //
// ./src/vuex/types.js